import React, { useState, useEffect, useRef } from "react";
import "./style.css";
import Overlay from "react-bootstrap/Overlay";
import { Modal, Button } from "react-bootstrap";
import CollectionHeader from "../../components/header/CollectionHeader";
import { IoIosArrowBack } from "react-icons/io";
import { FaTimes } from "react-icons/fa";
import axios from "axios";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useNavigate } from "react-router-dom";
import { GoReply } from "react-icons/go";
import {
  FaCircleExclamation,
} from "react-icons/fa6";

const Inspector = () => {
  const [shipments, setShipments] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [activeFilters, setActiveFilters] = useState({});
  const [statusModal, setStatusModal] = useState({ status: false, modal: "" });
  const [currentInspector, setCurrentInspector] = useState({});
  const [inputDisabled, setInputDisabled] = useState({
    turn: false,
    awb: false,
  });
  const [showOverlay, setShowOverlay] = useState({
    turn: false,
    awb: false,
    start: false,
    end: false,
  });

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [turnToConfirm, setTurnToConfirm] = useState(null);

  const handleValidarSalida = (id) => {
    setTurnToConfirm(id);
    setShowConfirmModal(true);
  };

  const confirmValidarSalida = async () => {
    try {
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/guard/${turnToConfirm}`;
      const res = await axios.post(url, { status: 1, user_id: localStorage.getItem("collection-email") }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
        },
      });

      Swal.fire({
        title: "Éxito",
        text: "Salida validada correctamente",
        icon: "success",
      });
      setShowConfirmModal(false);
      setTurnToConfirm(null);
      await getData(1, activeFilters, false); // Recarga la tabla si es necesario
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Error",
        text: "Ocurrió un error al validar salida",
        icon: "error",
      });
    }
  };

  const [formValues, setFormValues] = useState({
    start: "",
    end: "",
    turn: "",
    awb: "",
  });

  const navigate = useNavigate();

  const turnRef = useRef(null);
  const awbRef = useRef(null);
  const startRef = useRef(null);
  const endRef = useRef(null);

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const {
    register: register,
    handleSubmit: handleSubmitForm1,
    watch,
    reset: reset,
    setError,
    formState: { errors: errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      start: getCurrentDate(),
      end: getCurrentDate(),
    },
  });

  const turn = watch("turn");
  const awb = watch("awb");
  const start = watch("start");
  const end = watch("end");

  const onSubmit = async (data) => {
    if (new Date(data.start) > new Date(data.end)) {
      setError("start", {
        type: "manual",
        message: "La fecha de inicio no puede ser mayor que la de fin",
      });
      return;
    }

    const dateStart = formatDate(data.start);
    const dateEnd = formatDate(data.end);

    const newFilters = {
      startDate: dateStart,
      finishDate: dateEnd,
    };

    if (inputDisabled.turn && data.awb) {
      newFilters.awb = data.awb;
    }

    if (inputDisabled.awb && data.turn) {
      newFilters.turn = data.turn;
    }

    setActiveFilters(newFilters);
    await getData(1, newFilters, false);
  };

  function formatDate(dateISO) {
    const [year, month, day] = dateISO.split("-");
    return `${day}/${month}/${year}`;
  }

  const getData = async (pageNumber = 1, filters = {}, shouldAppend = false) => {
    if (loading) return;
    setLoading(true);
    try {
      let queryParams = [];
      queryParams.push(`page=${pageNumber}`);

      if (filters.startDate) queryParams.push(`startDate=${filters.startDate}`);
      if (filters.finishDate) queryParams.push(`finishDate=${filters.finishDate}`);
      if (filters.awb) queryParams.push(`awb=${filters.awb}`);
      if (filters.turn) queryParams.push(`turn=${filters.turn}`);

      const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
      const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/guard${queryString}`;

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
        },
      });

      if (res.data.code === 1) {
        const newCollections = res.data.collections || [];
        if (shouldAppend) {
          setShipments((prev) => [...prev, ...newCollections]);
        } else {
          setShipments(newCollections);
        }
        setPage(res.data.current_page || pageNumber);
        setTotalPages(res.data.total_pages || 1);
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setLoading(false);
    }
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - scrollTop - clientHeight <= 15) {
      if (!loading && page < totalPages) {
        getData(page + 1, activeFilters, true);
      }
    }
  };

  const clearFilters = async () => {
    reset({
      start: getCurrentDate(),
      end: getCurrentDate(),
      turn: "",
      awb: "",
    });
    setInputDisabled({ turn: false, awb: false });
    setActiveFilters({});
    await getData(1, {}, false);
  };

  const getStatusTextSerching = (status) => {
    switch (parseInt(status)) {
      case 1:
        return "Buscando";
      case 2:
        return "Encontrado";
      case 3:
        return "Encontrado Parcial";
      case 4:
        return "No Encontrado";
      default:
        return "--";
    }
  };

  const getStatusClassSerching = (status) => {
    switch (parseInt(status)) {
      case 1:
        return "searching";
      case 2:
        return "found";
      case 3:
        return "found-partial";
      case 4:
        return "not-found";
      default:
        return "null";
    }
  };

  const getStatusTextCounter = (status) => {
    switch (parseInt(status)) {
      case 1:
        return "Aceptado";
      case 0:
        return "No aceptado";
      default:
        return "--";
    }
  };

  const getStatusClassCounter = (status) => {
    switch (parseInt(status)) {
      case 1:
        return "accepted";
      case 0:
        return "not-accepted";
      default:
        return "null";
    }
  };

  const exportData = async () => {
    const startDate = new Date(formValues.start);
    const endDate = new Date(formValues.end);

    if (startDate > endDate) {
      Swal.fire({
        title: "Error",
        text: "La fecha de inicio no puede ser mayor que la de fin",
        icon: "error",
      });
      return;
    }

    const diffInMs = endDate - startDate;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    if (diffInDays > 7) {
      Swal.fire({
        title: "Error",
        text: "Por favor verifica que el rango de fecha sea menor a una semana",
        icon: "error",
      });
      return;
    }

    let url = "";
    let dateStart = "";
    let dateEnd = "";

    if (formValues.start === "" && formValues.end === "") {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0"); // +1 porque enero es 0
      const year = today.getFullYear();
      const formattedDate = `${day}-${month}-${year}`;

      dateStart = formattedDate;
      dateEnd = formattedDate;
      url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/guard`;
    } else {
      dateStart = formatDate(formValues.start);
      dateEnd = formatDate(formValues.end);
      url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/guard?startDate=${dateStart}&finishDate=${dateEnd}`;
    }

    try {
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
        },
      });

      if (res.data.collections.length === 0) {
        Swal.fire({
          title: "No existen datos",
          text: "No hay registros por mostrar en ese rango de fecha",
          icon: "info",
        });
        return;
      }

      const transformShipments = res.data.collections.map((item) => ({
        "# de turno": item.turn_number,
        "Nombre Buscador": item.employee_name,
        "Hora emisión": item.created_at ? formatHour(item.created_at) : "-",
        "# Guías/Cliente": item.awbs
          ? item.awbs
          : "" && item.customer_name
            ? item.customer_name
            : "",
        "Estatus Busqueda": item.status
          ? getStatusTextSerching(item.status)
          : "-",
        "Estatus Busqueda Mostrador": item.checkout_status
          ? getStatusTextCounter(item.checkout_status)
          : "-",
      }));

      await generateExcelExport(transformShipments, dateStart, dateEnd);
    } catch (error) {
      console.error(error);
    }
  };

  const generateExcelExport = async (data, startDate, endDate) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Inspector");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(blob, `inspector-${startDate}-${endDate}.xlsx`);
  };

  function formatHour(dateString) {
    const [datePart, timePart] = dateString.split(" ");
    const [day, month, year] = datePart.split("/");

    const isoFormat = `${year}-${month}-${day}T${timePart}`;

    const date = new Date(isoFormat);
    if (isNaN(date.getTime())) {
      return "Fecha inválida";
    }

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  const logOut = async () => {
    const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/user/logout`;
    const body = {
      user_id: localStorage.getItem("collection-email"),
      profile: localStorage.getItem("collection-profile"),
    };

    await axios.post(url, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
      },
    });
    localStorage.clear();
    navigate("/amc-domestico/collection/");
  };

  useEffect(() => {
    getData();

    // const interval = setInterval(getData, 15000);
    // return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (turn && turn.trim() !== "") {
      setInputDisabled((prev) => ({ ...prev, awb: true }));
    } else {
      setInputDisabled((prev) => ({ ...prev, awb: false }));
    }

    if (awb && awb.trim() !== "") {
      setInputDisabled((prev) => ({ ...prev, turn: true }));
    } else {
      setInputDisabled((prev) => ({ ...prev, turn: false }));
    }
  }, [turn, awb]);

  useEffect(() => {
    const subscription = watch((value) => {
      setFormValues({
        start: value.start || "",
        end: value.end || "",
        turn: value.turn || "",
        awb: value.awb || "",
      });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const getDetails = async (id) => {
    try {
      setStatusModal({ status: true, modal: "information" });

      if (id !== undefined) {
        const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/guard/${id}`;
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
          },
        });

        setCurrentInspector(response.data.data.turn);
      }
    } catch (error) {
      console.error("error", error);
      Swal.fire({
        title: "Error",
        text: "Ocurrio un error al obtener los detalles.",
        icon: "error",
      });
    }
  };

  const closeModal = () => {
    setStatusModal({ status: false, modal: "" });
    setCurrentInspector({});
  };

  const renderInformationModal = () => {
    return (
      <Modal
        show={statusModal.status && statusModal.modal === "information"}
        onHide={closeModal}
        className="modal-container-center"
      >
        <Modal.Body>
          <div className="modal-icon">
            <svg
              width="150"
              height="150"
              viewBox="0 0 150 150"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M75 150C84.8491 150 94.6018 148.06 103.701 144.291C112.801 140.522 121.069 134.997 128.033 128.033C134.997 121.069 140.522 112.801 144.291 103.701C148.06 94.6018 150 84.8491 150 75C150 65.1509 148.06 55.3982 144.291 46.2987C140.522 37.1993 134.997 28.9314 128.033 21.967C121.069 15.0026 112.801 9.47814 103.701 5.70903C94.6018 1.93993 84.8491 -1.46764e-07 75 0C55.1088 2.96403e-07 36.0322 7.90176 21.967 21.967C7.90176 36.0322 0 55.1088 0 75C0 94.8912 7.90176 113.968 21.967 128.033C36.0322 142.098 55.1088 150 75 150ZM73.0667 105.333L114.733 55.3333L101.933 44.6667L66.1 87.6583L47.5583 69.1083L35.775 80.8917L60.775 105.892L67.225 112.342L73.0667 105.333Z"
                fill="#66C87B"
              />
            </svg>
          </div>
          <p className="modal-text-seek">
            El{" "}
            <span className="seek-color-blue">
              turno {currentInspector.turn_number}
            </span>{" "}
            {currentInspector?.employee_name ? (
              <>
                ha sido asignado correctamente al empleado{" "}
                <span className="seek-color-blue">
                  {currentInspector.employee_name}
                </span>
              </>
            ) : (
              ""
            )}
          </p>

          <div className="tableSeekContainer">
            {((currentInspector.awbs && !currentInspector.customer_name) || (currentInspector.awb && !currentInspector.customer_name)) && (
              <table className="info-table">
                <thead>
                  <tr>
                    <th colSpan="4" className="title">
                      Información
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td colSpan="2" className="label-dark">
                      <p className="paddText">
                        Nombre de empleado asignado
                      </p>
                    </td>
                    <td colSpan="2" className="value">
                      {currentInspector.employee_name}
                    </td>
                  </tr>

                  <tr>
                    <td colSpan="2" className="label-dark">
                      <p className="paddText">
                        # de turno
                      </p>
                    </td>
                    <td colSpan="2" className="value highlight-number">
                      {currentInspector.turn_number}
                    </td>
                  </tr>

                  <tr>
                    <td colSpan="2" className="label-dark">
                      <p className="paddText">
                        # de guías
                      </p>
                    </td>
                    <td colSpan="2" className="value highlight-number">
                      {currentInspector.awb_total ? currentInspector.awb_total : 0}
                    </td>
                  </tr>


                  {currentInspector.awb && currentInspector.awb.map((awb, index) => (
                    <tr key={index}>
                      <td className="index">{index + 1}</td>
                      <td className="label-dark">Guía(s)</td>
                      <td className="value">
                        <span className="badge">{awb.awb}</span>
                      </td>

                      <td className="pieces">
                        <div className="pieces-container">
                          <span className="pieces-label"># de piezas</span>
                          {/* <span className="badge small">{awb.piezas}</span> */}
                          <span className="badge small">{awb.pieces}</span>
                        </div>
                      </td>
                    </tr>
                  ))}

                </tbody>
              </table>
            )}
          </div>

          <div className="guide-container">
            <h3 className="seek-color-blue-bold">
              {currentInspector.customer_name}
            </h3>

            {currentInspector.customer_name && (
              <p>Total de guías: {currentInspector.awb_total === 0 ? "-" : currentInspector.awb_total}</p>
            )}

            <Button
              className="btn-confirm-seek"
              onClick={() => {
                closeModal();
                // updateAll();
              }}
            >
              Continuar
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  return (
    <>
      <div className="collection-inpector">
        <CollectionHeader />
        <div className="collection-inpector-body">
          <div className="return-container">
            <button type="button" className="return-btn" onClick={logOut}>
              <IoIosArrowBack className="arrow-btn" />
            </button>
          </div>

          <h4>Guardia de Salida</h4>

          <div className="actions-container-cl">
            <form onSubmit={handleSubmitForm1(onSubmit)}>
              <div className="inputs-con">
                <div className="input-ind">
                  <div class="form-floating mb-3">
                    <input
                      type="text"
                      class={`form-control ${errors.turn ? "is-invalid" : ""}`}
                      id="turn"
                      name="turn"
                      placeholder="Turno"
                      {...register("turn", {
                        pattern: {
                          value: /^[0-9]+$/,
                          message: "Solo se permiten números",
                        },
                      })}
                      ref={(e) => {
                        register("turn").ref(e);
                        turnRef.current = e;
                      }}
                      onFocus={() =>
                        setShowOverlay((prev) => ({ ...prev, turn: true }))
                      }
                      onBlur={() =>
                        setShowOverlay((prev) => ({ ...prev, turn: false }))
                      }
                    />
                    <label for="turn">Turno</label>
                    <Overlay
                      target={turnRef.current}
                      show={!!errors.turn && showOverlay.turn}
                      placement="top"
                    >
                      {(props) => (
                        <div
                          {...props}
                          style={{
                            backgroundColor: "rgba(255, 0, 0, 0.85)",
                            padding: "5px 10px",
                            color: "white",
                            borderRadius: 4,
                            fontSize: 12,
                            zIndex: 9999,
                            marginBottom: "10px",
                            ...props.style,
                          }}
                        >
                          {errors.turn?.message}
                        </div>
                      )}
                    </Overlay>
                  </div>
                </div>
                <div className="input-ind">
                  <div class="form-floating mb-3">
                    <input
                      type="text"
                      class={`form-control ${errors.awb ? "is-invalid" : ""}`}
                      id="awb"
                      name="awb"
                      placeholder="Guía"
                      {...register("awb", {
                        pattern: {
                          value: /^\d{3}-\d{8}$|^\d{10}$/,
                          message: "Formato No. Guía invalido",
                        },
                      })}
                      ref={(e) => {
                        register("awb").ref(e);
                        awbRef.current = e;
                      }}
                      onFocus={() =>
                        setShowOverlay((prev) => ({ ...prev, awb: true }))
                      }
                      onBlur={() =>
                        setShowOverlay((prev) => ({ ...prev, awb: false }))
                      }
                    />
                    <label for="awb">Campo/Guía</label>
                    <Overlay
                      target={awbRef.current}
                      show={!!errors.awb && showOverlay.awb}
                      placement="top"
                    >
                      {(props) => (
                        <div
                          {...props}
                          style={{
                            backgroundColor: "rgba(255, 0, 0, 0.85)",
                            padding: "5px 10px",
                            color: "white",
                            borderRadius: 4,
                            fontSize: 12,
                            zIndex: 9999,
                            marginBottom: "10px",
                            ...props.style,
                          }}
                        >
                          {errors.awb?.message}
                        </div>
                      )}
                    </Overlay>
                  </div>
                </div>
                <div className="input-ind">
                  <div class="form-floating mb-3">
                    <input
                      type="date"
                      class={`form-control ${errors.start ? "is-invalid" : ""}`}
                      id="start"
                      name="start"
                      placeholder="Fecha inicio"
                      {...register("start", {
                        required: "Selecciona una fecha de inicio",
                        validate: (value) => {
                          if (start && end && new Date(value) > new Date(end)) {
                            return "La fecha de inicio no puede ser mayor que la de fin";
                          }
                          return true;
                        },
                      })}
                      ref={(e) => {
                        register("start").ref(e);
                        startRef.current = e;
                      }}
                      onFocus={() =>
                        setShowOverlay((prev) => ({ ...prev, start: true }))
                      }
                      onBlur={() =>
                        setShowOverlay((prev) => ({ ...prev, start: false }))
                      }
                    />
                    <label for="start">Fecha inicio</label>
                    <Overlay
                      target={startRef.current}
                      show={!!errors.start && showOverlay.start}
                      placement="top"
                    >
                      {(props) => (
                        <div
                          {...props}
                          style={{
                            backgroundColor: "rgba(255, 0, 0, 0.85)",
                            padding: "5px 10px",
                            color: "white",
                            borderRadius: 4,
                            fontSize: 12,
                            zIndex: 9999,
                            marginBottom: "10px",
                            ...props.style,
                          }}
                        >
                          {errors.start?.message}
                        </div>
                      )}
                    </Overlay>
                  </div>
                </div>
                <div className="input-ind">
                  <div class="form-floating mb-3">
                    <input
                      type="date"
                      class={`form-control ${errors.end ? "is-invalid" : ""}`}
                      id="end"
                      name="end"
                      placeholder="Fecha fin"
                      {...register("end", {
                        required: "Selecciona una fecha de fin",
                      })}
                      ref={(e) => {
                        register("end").ref(e);
                        endRef.current = e;
                      }}
                      onFocus={() =>
                        setShowOverlay((prev) => ({ ...prev, end: true }))
                      }
                      onBlur={() =>
                        setShowOverlay((prev) => ({ ...prev, end: false }))
                      }
                    />
                    <label for="floatingInput">Fecha fin</label>
                    <Overlay
                      target={endRef.current}
                      show={!!errors.end && showOverlay.end}
                      placement="top"
                    >
                      {(props) => (
                        <div
                          {...props}
                          style={{
                            backgroundColor: "rgba(255, 0, 0, 0.85)",
                            padding: "5px 10px",
                            color: "white",
                            borderRadius: 4,
                            fontSize: 12,
                            zIndex: 9999,
                            marginBottom: "10px",
                            ...props.style,
                          }}
                        >
                          {errors.end?.message}
                        </div>
                      )}
                    </Overlay>
                  </div>
                </div>
              </div>
              <div className="buttons-con">
                <button
                  type="submit"
                  className="btn_filter_cl"
                  id="btn_filter"
                  disabled={
                    !formValues.start ||
                    !formValues.end ||
                    (!formValues.turn && !formValues.awb)
                  }
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  className="dlt_filter_cl"
                  id="dlt_filter"
                  onClick={clearFilters}
                >
                  Borrar filtros
                </button>
                <button
                  type="button"
                  className="export_btn_cl"
                  onClick={exportData}
                >
                  Exportar
                </button>
              </div>
            </form>
          </div>

          <div className="table-container" onScroll={handleScroll}>
            <table>
              <thead>
                <tr>
                  <th># Turno</th>
                  <th>Nombre Buscador</th>
                  <th>Hora emisión</th>
                  <th># Guías/Cliente</th>
                  <th>Estatus Busqueda</th>
                  <th>Estatus Busqueda Mostrador</th>
                  <th>Acciones</th>
                  <th style={{ background: "#fff", border: "none" }}></th>
                </tr>
              </thead>

              <tbody>
                {shipments.map((row, index) => (
                  <tr
                    key={index}
                    style={{
                      background:
                        index % 2 === 0 ? "FFFFFF" : "rgba(213, 212, 212, 1)",
                    }}
                  >
                    <td style={{
                      backgroundColor: row.inspection_status !== null ? '#66c87b' : ''
                    }}>{row?.turn_number ? row?.turn_number : "-"}
                    </td>
                    <td>{row?.employee_name ? row?.employee_name : "-"}</td>
                    <td>
                      {row?.created_at ? formatHour(row?.created_at) : "-"}
                    </td>
                    <td>
                      {row?.awbs ? row?.awbs : ""}
                      {row?.customer_name ? row?.customer_name : ""}
                    </td>
                    <td>
                      <span
                        className={`status ${getStatusClassSerching(
                          row?.status
                        )}`}
                      >
                        {row?.status ? getStatusTextSerching(row?.status) : "-"}
                      </span>
                    </td>
                    <td>
                      <span
                        className={`status ${getStatusClassCounter(
                          row?.checkout_status
                        )}`}
                      >
                        {row?.checkout_status
                          ? getStatusTextCounter(row?.checkout_status)
                          : "-"}
                      </span>
                    </td>
                    <td>
                      <div className="d-flex">

                        <div
                          className="box-container-inspect-gray"
                          onClick={() => getDetails(row.id)}
                        >
                          <div className="tooltip-insp">Ver detalle</div>
                          <FaCircleExclamation />
                        </div>

                        {(parseInt(row?.status) === 2 || parseInt(row?.status) === 3) && parseInt(row?.checkout_status) === 1 && row.inspection_status === null && (
                          <>
                            <button
                              type="button"
                              className="box-container-inspect-red"
                              onClick={() => handleValidarSalida(row?.id)}
                            >
                              <div className="tooltip-insp">Validar salida</div>
                              <GoReply />
                            </button>
                          </>
                        )}

                      </div>

                    </td>



                  </tr>
                ))}
              </tbody>
            </table>
            {loading && <div className="loading-scroll">Cargando...</div>}
          </div>
        </div>
      </div>

      <Modal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        className="modal-container-center confirm-modal-inspector"
        centered
      >
        <Modal.Body>
          <div className="modal-icon-question">
            ?
          </div>

          <h3 className="modal-text-confirm">
            ¿Deseas validar la salida al turno?
          </h3>

          <div className="modal-buttons-confirm">
            <Button
              className="btn-cancel-modal"
              onClick={() => setShowConfirmModal(false)}
            >
              Cancelar
            </Button>
            <Button
              className="btn-confirm-modal"
              onClick={confirmValidarSalida}
            >
              Confirmar
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Justification Modal */}
      {renderInformationModal()}
    </>
  );
};

export default Inspector;
